/**
 * 只有数字和字母的正则 并且限制于八位数字
 * @param str
 * @returns {boolean}
 */
export function numLetter(str) {
  const reg = /^([a-z]|[A-Z]|[0-9]){8}$/;
  return reg.test(str);
}

/**
 * 只能输入数字或者小数
 * @param str
 * @returns {boolean}
 */
export function integerDecimal(str) {
  const reg = /^[0-9]+([.]{1}[0-9]+){0,1}$/;
  return reg.test(str);
}
/**
 * 只能输入正整数
 * @param str
 * @returns {boolean}
 */
export function positiveInteger(str) {
  const reg = /^[1-9]\d*$/;
  return reg.test(str);
}

/**
 * 手机号
 * @param str
 * @returns {boolean}
 */
export function phone(str) {
  const reg = /^([0-9]){11}$/;
  return reg.test(str);
}
/**
 * 身份证
 * @param str
 * @returns {boolean}
 */
export function idCard(str) {
  const reg = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
  return reg.test(str);
}

/**
 * 邮箱
 * @param str
 * @returns {boolean}
 */
export function email(str) {
  // const reg = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
  const reg = /^[A-Za-zd0-9]+([-_.][A-Za-zd]+)*@([A-Za-zd]+[-.])+[A-Za-zd]{2,5}$/;
  return reg.test(str);
}

/**
 * 14字符
 至少1数字字符
 至少1小写字母
 至少1大写字母
 * @param str
 * @returns {boolean}
 */
export function passWord(str) {
  const reg = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{14}$/;
  return reg.test(str);
}
